import React from "react";
import styled from "styled-components";
import { faUser } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { BASE_GITHUB_URL } from "@utils";

interface UserPhotoProps {
  username?: string;
  profile_photo?: string;
  alt?: string;
  large?: boolean;
  small?: boolean;
  square?: boolean;
}

interface ImgProps {
  large: boolean;
  small: boolean;
  square: boolean;
}

const PhotoDiv = styled.span`
  line-height: unset;
`;

const UserImg = styled.img<ImgProps>`
  border-radius: ${(props) => (props.large || props.square ? "5px" : "50%")};
  margin-left: 8px;
  width: ${(props) => (props.large ? "100px" : props.small ? "20px" : "28px")};
  height: ${(props) => (props.large ? "100px" : props.small ? "20px" : "28px")};
  cursor: pointer;
`;

const makePhotoUrl = (username: string, large?: boolean) =>
  `${BASE_GITHUB_URL}${username}.png?size=${large ? 400 : 56}`;

export const UserPhoto: React.FC<UserPhotoProps> = ({
  username,
  profile_photo,
  alt,
  large,
  small,
  square,
}) => {
  let src: string | undefined;
  if (profile_photo) {
    src = profile_photo;
  } else if (username) {
    src = makePhotoUrl(username, large);
  }

  return (
    <PhotoDiv>
      {src ? (
        // semgrep false positive: src is not coming from user input
        <UserImg
          src={src}
          alt={alt || "profile photo"}
          large={!!large}
          small={!!small}
          square={!!square}
        /> // nosem: typescript.react.security.audit.react-http-leak.react-http-leak
      ) : (
        <FontAwesomeIcon icon={faUser} style={{ marginRight: "4px" }} />
      )}
    </PhotoDiv>
  );
};
